export default "/_next/static/images/arViewImage-e49b323617270cc3026cdec18ffe2d18.png";